import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUpdateFileCategoryPayload } from 'api/actions/hr-update-file-category/hr-update-file-category-payload';
import { HrUpdateFileCategoryPathParameters } from 'api/actions/hr-update-file-category/hr-update-file-category-path-parameters';
import { HrUpdateFileCategoryResponse } from 'api/actions/hr-update-file-category/hr-update-file-category-response';

type HrUpdateFileCategoryQueryParameters = Record<string, any>;

/**
 * The path of the HrUpdateFileCategory action.
 */
export const hrUpdateFileCategoryActionPath = new SweetPath<keyof HrUpdateFileCategoryPathParameters>(
  '/api/hr/file-categories/{categoryId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrUpdateFileCategory actions.
 */
export default function createHrUpdateFileCategoryAction(axios: AxiosInstance) {
  return function hrUpdateFileCategoryAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUpdateFileCategoryPathParameters;
    query?: HrUpdateFileCategoryQueryParameters;
    payload: HrUpdateFileCategoryPayload;
  }) {
    const path = hrUpdateFileCategoryActionPath.insert(parameters);

    return axios.request<HrUpdateFileCategoryResponse, HrUpdateFileCategoryResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
